import React from 'react';

import { TerminationGeneratorViewHeader } from 'app/components/TerminationGeneratorViewHeader';
import { TerminationGeneratorForm } from 'app/components/TerminationGeneratorForm';

export default function TerminationGeneratorView() {
  return (
    <>
      <div id="seo-prerender" />
      <TerminationGeneratorViewHeader />
      <TerminationGeneratorForm />
    </>
  );
}
